export const getExternalShippingCarrierMagentoAddress = (externalShippingProviderAddress) => {
    const { storeId, storeName, streetName, postCode, city, countryCode, countryName, streetNumber } = externalShippingProviderAddress;
    return {
        isPickupAddress: true,
        pickupInformation: {
            store_id: storeId,
            store_name: storeName,
        },
        streetNumber: streetNumber || "",
        streetName,
        city,
        countryCode,
        countryName,
        streetAdditional: "",
        postcode: postCode,
    };
};
//# sourceMappingURL=getExternalShippingCarrierMagentoAddress.js.map